// eslint-disable-next-line spaced-comment
export default ({ size, color = '#000' } = {}) => /*html*/`
  <svg width="${ size }" height="${ size }" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.1518 7.77327L7.5374 1.18559C7.84526 0.867967 8.34468 0.867967 8.65254 1.18559L9.39739 1.95405C9.70492 2.27133 9.70525 2.78522 9.3987 3.10318L4.33786 8.34852L9.39838 13.5942C9.70525 13.9122 9.7046 14.426 9.39706 14.7433L8.65221 15.5118C8.34435 15.8294 7.84493 15.8294 7.53707 15.5118L1.1518 8.92376C0.843933 8.60614 0.843933 8.0909 1.1518 7.77327Z" fill="${ color }"/>
  </svg>
`
